import PropTypes from "prop-types";

import { useState } from "react";
import { ChatContext } from "./context";

export const ChatContextProvider = ({ children }) => {
  const [replyId, setReplyId] = useState(null);
  const [showChat, setShowChat] = useState(true);
  const [chatType, setChatType] = useState("group_chat");
  const [users, setUsers] = useState([]);

  return (
    <ChatContext.Provider
      value={{
        replyId,
        setReplyId,
        showChat,
        setShowChat,
        chatType,
        setChatType,
        users,
        setUsers,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

ChatContextProvider.propTypes = {
  children: PropTypes.any,
};
